import { useState } from "react";

export default function BlockImage({ block, setBlocks, updateBlock, className, isEditing }) {
  let space = block.height;
  if(space == null){
    space = '50px   ';
  }
  // Use an object for style, not a string
  let styleSpace = {};
  if (isEditing) {
    styleSpace.borderTop = "2px dashed blue";
    styleSpace.borderBottom = "2px dashed blue";
  }

  return (
    <div className={`rounded-xl  w-full ${className || ''}`}>
      <div className="flex items-center justify-center rounded" style={styleSpace}>
        <div
          style={{ height: space }}
          id={`space-${block.id}`}
        ></div>
      </div>
    </div>
  );
}